export const currencySymbolByPointOfSale = {
    de: "EUR",
    es: "EUR",
    it: "EUR",
    nl: "EUR",
    ie: "EUR",
    at: "EUR",
    be: "EUR",
    se: "SEK",
    no: "NOK",
    ro: "EUR",
    dk: "DKK",
    fi: "EUR",
    us: "USD",
    fr: "EUR",
    gb: "GBP",
    au: "AUD",
    ua: "UAH",
    pl: "PLN",
    ch: "CHF",
    pt: "EUR",
    qa: "QAR",
    ph: "USD",
    th: "THB",
    ae: "AED",
    cl: "CLP",
    cz: "CZK",
    hu: "HUF",
    is: "EUR",
    in: "INR",
    bh: "USD",
    kw: "KWD",
    rs: "EUR",
    id: "IDR",
    om: "USD",
    hk: "HKD",
    lu: "EUR",
    ca: "CAD",
    jp: "JPY",
    mt: "EUR",
    cy: "EUR",
    hr: "EUR",
    ee: "EUR",
    bg: "BGN",
    co: "COP",
    mx: "MXN",
    nz: "NZD",
    gr: "EUR",
    kz: "KZT",
    pe: "PEN",
    mo: "HKD",
    br: "BRL",
    my: "MYR",
    sa: "SAR",
    kr: "KRW",
    vn: "VND",
    sg: "SGD",
    za: "ZAR"
};
export const currencySymbolByPointOfSaleForPosBg = {
    de: "EUR",
    es: "EUR",
    it: "EUR",
    nl: "EUR",
    ie: "EUR",
    at: "EUR",
    be: "EUR",
    se: "SEK",
    no: "NOK",
    ro: "EUR",
    dk: "DKK",
    fi: "EUR",
    us: "USD",
    fr: "EUR",
    gb: "GBP",
    au: "AUD",
    ua: "UAH",
    pl: "PLN",
    ch: "CHF",
    pt: "EUR",
    qa: "QAR",
    ph: "USD",
    th: "THB",
    ae: "AED",
    cl: "CLP",
    cz: "CZK",
    hu: "HUF",
    is: "EUR",
    in: "INR",
    bh: "USD",
    kw: "KWD",
    rs: "EUR",
    id: "IDR",
    om: "USD",
    hk: "HKD",
    lu: "EUR",
    ca: "CAD",
    jp: "JPY",
    mt: "EUR",
    cy: "EUR",
    hr: "EUR",
    ee: "EUR",
    bg: "EUR",
    co: "COP",
    mx: "MXN",
    nz: "NZD",
    gr: "EUR",
    kz: "KZT",
    pe: "PEN",
    mo: "HKD",
    br: "BRL",
    my: "MYR",
    sa: "SAR",
    kr: "KRW",
    vn: "VND",
    sg: "SGD",
    za: "ZAR"
};
export const accommodationsCurrencySymbolByCountry = {
    ae: "AED",
    af: "AFN",
    al: "ALL",
    am: "AMD",
    an: "ANG",
    ar: "ARS",
    au: "AUD",
    cc: "AUD",
    ki: "AUD",
    nf: "AUD",
    nr: "AUD",
    sb: "AUD",
    tv: "AUD",
    aw: "AWG",
    az: "AZN",
    ba: "BAM",
    bb: "BBD",
    bd: "BDT",
    bg: "BGN",
    bh: "BHD",
    bm: "BMD",
    bn: "BND",
    bo: "BOB",
    br: "BRL",
    bs: "BSD",
    bt: "BTN",
    bw: "BWP",
    by: "BYN",
    bz: "BZD",
    ca: "CAD",
    ch: "CHF",
    li: "CHF",
    cl: "CLP",
    cn: "CNY",
    co: "COP",
    cr: "CRC",
    cv: "CVE",
    cz: "CZK",
    dk: "DKK",
    fo: "DKK",
    gl: "DKK",
    do: "DOP",
    dz: "DZD",
    eg: "EGP",
    ad: "EUR",
    at: "EUR",
    be: "EUR",
    bl: "EUR",
    cy: "EUR",
    de: "EUR",
    ee: "EUR",
    es: "EUR",
    fi: "EUR",
    fr: "EUR",
    fx: "EUR",
    gf: "EUR",
    gm: "EUR",
    gp: "EUR",
    gr: "EUR",
    gw: "EUR",
    hr: "EUR",
    ie: "EUR",
    it: "EUR",
    km: "EUR",
    lt: "EUR",
    lu: "EUR",
    lv: "EUR",
    mc: "EUR",
    me: "EUR",
    mf: "EUR",
    mg: "EUR",
    mq: "EUR",
    mt: "EUR",
    nl: "EUR",
    pm: "EUR",
    pt: "EUR",
    re: "EUR",
    si: "EUR",
    sk: "EUR",
    sm: "EUR",
    xk: "EUR",
    xy: "EUR",
    yt: "EUR",
    fj: "FJD",
    fk: "GBP",
    gb: "GBP",
    gi: "GBP",
    im: "GBP",
    sh: "GBP",
    uk: "GBP",
    vg: "GBP",
    ge: "GEL",
    gh: "GHS",
    gt: "GTQ",
    gn: "GNF",
    gy: "GYD",
    ht: "HTG",
    hn: "HNL",
    hk: "HKD",
    hu: "HUF",
    is: "ISK",
    in: "INR",
    id: "IDR",
    ir: "IRR",
    iq: "IQD",
    il: "ILS",
    jm: "JMD",
    jp: "JPY",
    jo: "JOD",
    kz: "KZT",
    ke: "KES",
    kp: "KPW",
    kr: "KRW",
    kw: "KWD",
    kg: "KGS",
    la: "LAK",
    lb: "LBP",
    ls: "LSL",
    lr: "LRD",
    ly: "LYD",
    mo: "MOP",
    mk: "MKD",
    mw: "MWK",
    my: "MYR",
    mv: "MVR",
    ml: "XOF",
    mx: "MXN",
    md: "MDL",
    mn: "MNT",
    ma: "MAD",
    mz: "MZN",
    mm: "MMK",
    na: "NAD",
    np: "NPR",
    nz: "NZD",
    ni: "NIO",
    ne: "XOF",
    ng: "NGN",
    no: "NOK",
    om: "OMR",
    pk: "PKR",
    pa: "PAB",
    pg: "PGK",
    py: "PYG",
    pe: "PEN",
    ph: "PHP",
    pl: "PLN",
    qa: "QAR",
    ro: "RON",
    ru: "RUB",
    rw: "RWF",
    ws: "WST",
    st: "STN",
    sa: "SAR",
    sn: "XOF",
    rs: "RSD",
    sc: "SCR",
    sl: "SLL",
    sg: "SGD",
    so: "SOS",
    za: "ZAR",
    ss: "SSP",
    lk: "LKR",
    sd: "SDG",
    sr: "SRD",
    sz: "SZL",
    se: "SEK",
    sy: "SYP",
    tw: "TWD",
    tj: "TJS",
    tz: "TZS",
    th: "THB",
    tg: "XOF",
    to: "TOP",
    tt: "TTD",
    tn: "TND",
    tr: "TRY",
    tm: "TMT",
    ug: "UGX",
    ua: "UAH",
    us: "USD",
    uy: "UYU",
    uz: "UZS",
    vu: "VUV",
    ve: "VES",
    vn: "VND",
    ye: "YER",
    zm: "ZMW",
    zw: "ZWL"
};
export const accommodationsCurrencySymbolByCountryForPosBg = {
    ae: "AED",
    af: "AFN",
    al: "ALL",
    am: "AMD",
    an: "ANG",
    ar: "ARS",
    au: "AUD",
    cc: "AUD",
    ki: "AUD",
    nf: "AUD",
    nr: "AUD",
    sb: "AUD",
    tv: "AUD",
    aw: "AWG",
    az: "AZN",
    ba: "BAM",
    bb: "BBD",
    bd: "BDT",
    bg: "EUR",
    bh: "BHD",
    bm: "BMD",
    bn: "BND",
    bo: "BOB",
    br: "BRL",
    bs: "BSD",
    bt: "BTN",
    bw: "BWP",
    by: "BYN",
    bz: "BZD",
    ca: "CAD",
    ch: "CHF",
    li: "CHF",
    cl: "CLP",
    cn: "CNY",
    co: "COP",
    cr: "CRC",
    cv: "CVE",
    cz: "CZK",
    dk: "DKK",
    fo: "DKK",
    gl: "DKK",
    do: "DOP",
    dz: "DZD",
    eg: "EGP",
    ad: "EUR",
    at: "EUR",
    be: "EUR",
    bl: "EUR",
    cy: "EUR",
    de: "EUR",
    ee: "EUR",
    es: "EUR",
    fi: "EUR",
    fr: "EUR",
    fx: "EUR",
    gf: "EUR",
    gm: "EUR",
    gp: "EUR",
    gr: "EUR",
    gw: "EUR",
    hr: "EUR",
    ie: "EUR",
    it: "EUR",
    km: "EUR",
    lt: "EUR",
    lu: "EUR",
    lv: "EUR",
    mc: "EUR",
    me: "EUR",
    mf: "EUR",
    mg: "EUR",
    mq: "EUR",
    mt: "EUR",
    nl: "EUR",
    pm: "EUR",
    pt: "EUR",
    re: "EUR",
    si: "EUR",
    sk: "EUR",
    sm: "EUR",
    xk: "EUR",
    xy: "EUR",
    yt: "EUR",
    fj: "FJD",
    fk: "GBP",
    gb: "GBP",
    gi: "GBP",
    im: "GBP",
    sh: "GBP",
    uk: "GBP",
    vg: "GBP",
    ge: "GEL",
    gh: "GHS",
    gt: "GTQ",
    gn: "GNF",
    gy: "GYD",
    ht: "HTG",
    hn: "HNL",
    hk: "HKD",
    hu: "HUF",
    is: "ISK",
    in: "INR",
    id: "IDR",
    ir: "IRR",
    iq: "IQD",
    il: "ILS",
    jm: "JMD",
    jp: "JPY",
    jo: "JOD",
    kz: "KZT",
    ke: "KES",
    kp: "KPW",
    kr: "KRW",
    kw: "KWD",
    kg: "KGS",
    la: "LAK",
    lb: "LBP",
    ls: "LSL",
    lr: "LRD",
    ly: "LYD",
    mo: "MOP",
    mk: "MKD",
    mw: "MWK",
    my: "MYR",
    mv: "MVR",
    ml: "XOF",
    mx: "MXN",
    md: "MDL",
    mn: "MNT",
    ma: "MAD",
    mz: "MZN",
    mm: "MMK",
    na: "NAD",
    np: "NPR",
    nz: "NZD",
    ni: "NIO",
    ne: "XOF",
    ng: "NGN",
    no: "NOK",
    om: "OMR",
    pk: "PKR",
    pa: "PAB",
    pg: "PGK",
    py: "PYG",
    pe: "PEN",
    ph: "PHP",
    pl: "PLN",
    qa: "QAR",
    ro: "RON",
    ru: "RUB",
    rw: "RWF",
    ws: "WST",
    st: "STN",
    sa: "SAR",
    sn: "XOF",
    rs: "RSD",
    sc: "SCR",
    sl: "SLL",
    sg: "SGD",
    so: "SOS",
    za: "ZAR",
    ss: "SSP",
    lk: "LKR",
    sd: "SDG",
    sr: "SRD",
    sz: "SZL",
    se: "SEK",
    sy: "SYP",
    tw: "TWD",
    tj: "TJS",
    tz: "TZS",
    th: "THB",
    tg: "XOF",
    to: "TOP",
    tt: "TTD",
    tn: "TND",
    tr: "TRY",
    tm: "TMT",
    ug: "UGX",
    ua: "UAH",
    us: "USD",
    uy: "UYU",
    uz: "UZS",
    vu: "VUV",
    ve: "VES",
    vn: "VND",
    ye: "YER",
    zm: "ZMW",
    zw: "ZWL"
};
